import { EnrollmentInput } from "@outschool/gql-frontend-generated";
import { CurrentUser, useTrackLearnerCreated } from "@outschool/ui-auth";
import { useCallback } from "react";

import * as User from "../../shared/User";

export function useTrackLearnerCreatedDuringEnrollment() {
  const trackLearnerCreated = useTrackLearnerCreated();

  return useCallback(
    (
      enrollmentInputs: EnrollmentInput[],
      enrollingParent: Pick<
        NonNullable<CurrentUser>,
        "uid" | "created_at" | "children"
      >,
    ) => {
      if (!User.isNewUser(enrollingParent.created_at)) {
        return;
      }

      const enrollingLearners = enrollmentInputs
        .map(input => input.learner)
        .filter((learner): learner is NonNullable<typeof learner> => !!learner);
      const newLearners = enrollingLearners.filter(
        learner => learner.uid === null,
      );

      if (newLearners.length) {
        for (let i = 0; i < newLearners.length; i++) {
          trackLearnerCreated({
            is_first_learner: !enrollingParent.children.length && i === 0,
            parent_id: enrollingParent.uid,
          });
        }
      }
    },
    [trackLearnerCreated],
  );
}
